/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BalancePage = lazyLoad(
  () => import('./index'),
  module => module.BalancePage
);
